import {CommonModule} from '@angular/common';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {SharedUtilsModule, TrackingModule} from '@ox/utils';
import {AemDataService} from './aem-data';
import {ShopDataService} from './shop-data';
import {CopyFormattingService} from './copy-formatting';
import {PaymentMethodService} from './payment-method';
import {ShopService} from './shop-service';

@NgModule({schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        SharedUtilsModule,
        TrackingModule], providers: [
        ShopDataService,
        AemDataService,
        CopyFormattingService,
        PaymentMethodService,
        ShopService,
        provideHttpClient(withInterceptorsFromDi())
    ]})
export class ShopServiceModule {
}
